import React from "react";
import { toast } from "react-toastify";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { TOAST_CONFIG } from "./hooks";

export function ShowSuccessToast(message: string) {
    toast.success(message, {
        ...TOAST_CONFIG,
        icon: <CheckboxIcon height={25} width={25} fill="white" />,
    });
}
